// Phone number utilities for country-code-aware formatting

export interface CountryPhone {
  code: string;       // ISO 3166-1 alpha-2
  dialCode: string;   // e.g. "+254"
  flag: string;       // emoji flag
  name: string;
  maxDigits: number;  // digits after dial code
  placeholder: string;
}

export const COUNTRY_PHONES: CountryPhone[] = [
  { code: 'KE', dialCode: '+254', flag: '🇰🇪', name: 'Kenya', maxDigits: 9, placeholder: '712 345 678' },
  { code: 'US', dialCode: '+1', flag: '🇺🇸', name: 'United States', maxDigits: 10, placeholder: '212 555 0100' },
  { code: 'GB', dialCode: '+44', flag: '🇬🇧', name: 'United Kingdom', maxDigits: 10, placeholder: '7911 123456' },
  { code: 'NG', dialCode: '+234', flag: '🇳🇬', name: 'Nigeria', maxDigits: 10, placeholder: '802 345 6789' },
  { code: 'ZA', dialCode: '+27', flag: '🇿🇦', name: 'South Africa', maxDigits: 9, placeholder: '71 234 5678' },
  { code: 'IN', dialCode: '+91', flag: '🇮🇳', name: 'India', maxDigits: 10, placeholder: '98765 43210' },
  { code: 'AE', dialCode: '+971', flag: '🇦🇪', name: 'UAE', maxDigits: 9, placeholder: '50 123 4567' },
  { code: 'KW', dialCode: '+965', flag: '🇰🇼', name: 'Kuwait', maxDigits: 8, placeholder: '5000 0000' },
  { code: 'SE', dialCode: '+46', flag: '🇸🇪', name: 'Sweden', maxDigits: 9, placeholder: '70 123 4567' },
  { code: 'FR', dialCode: '+33', flag: '🇫🇷', name: 'France', maxDigits: 9, placeholder: '6 12 34 56 78' },
  { code: 'DE', dialCode: '+49', flag: '🇩🇪', name: 'Germany', maxDigits: 11, placeholder: '151 23456789' },
  { code: 'TZ', dialCode: '+255', flag: '🇹🇿', name: 'Tanzania', maxDigits: 9, placeholder: '712 345 678' },
  { code: 'UG', dialCode: '+256', flag: '🇺🇬', name: 'Uganda', maxDigits: 9, placeholder: '712 345 678' },
  { code: 'ET', dialCode: '+251', flag: '🇪🇹', name: 'Ethiopia', maxDigits: 9, placeholder: '911 234 567' },
  { code: 'PK', dialCode: '+92', flag: '🇵🇰', name: 'Pakistan', maxDigits: 10, placeholder: '300 1234567' },
  { code: 'SA', dialCode: '+966', flag: '🇸🇦', name: 'Saudi Arabia', maxDigits: 9, placeholder: '50 123 4567' },
  { code: 'QA', dialCode: '+974', flag: '🇶🇦', name: 'Qatar', maxDigits: 8, placeholder: '5000 0000' },
  { code: 'EG', dialCode: '+20', flag: '🇪🇬', name: 'Egypt', maxDigits: 10, placeholder: '100 123 4567' },
  { code: 'GH', dialCode: '+233', flag: '🇬🇭', name: 'Ghana', maxDigits: 9, placeholder: '20 123 4567' },
  { code: 'RW', dialCode: '+250', flag: '🇷🇼', name: 'Rwanda', maxDigits: 9, placeholder: '780 123 456' },
];

export function getCountryByCode(code: string): CountryPhone {
  return COUNTRY_PHONES.find(c => c.code === code) || COUNTRY_PHONES[0];
}

export function formatPhoneDisplay(digits: string, country: CountryPhone): string {
  // Simple grouping: split into chunks of 3
  const clean = digits.replace(/\D/g, '').slice(0, country.maxDigits);
  if (clean.length <= 3) return clean;
  if (clean.length <= 6) return `${clean.slice(0, 3)} ${clean.slice(3)}`;
  return `${clean.slice(0, 3)} ${clean.slice(3, 6)} ${clean.slice(6)}`;
}

export function buildFullPhone(digits: string, country: CountryPhone): string {
  const clean = digits.replace(/\D/g, '').slice(0, country.maxDigits);
  return `${country.dialCode}${clean}`;
}
